// extracted by mini-css-extract-plugin
export default {"skills":"SkillsList_skills__fjDgN"};